<template>
    <div>
        <slot></slot>
        <Page :total="total" class="QHPage" @on-change="pageNoChange" @on-page-size-change="pageSizeChange" />
    </div>
</template>

<script>
export default {
    name: 'QHTable',
    props: {
        total: {
            type: Number,
            required: true
        },
        pageThis: {
            type: Object,
            required: true
        }
    },
    methods: {
        pageNoChange(e) {
            this.pageThis.searchMap.pageNo = e;
            this.pageThis.getList();
        },
        pageSizeChange(e) {
            this.pageThis.searchMap.pageSize = e;
            this.pageThis.getList();
        },
    }
};
</script>